module.exports = __webpack_public_path__ + "img/bg_g.1415672d.png";